<template>
    <div class="step-configure col-12">
        <form @submit.prevent="save">
            <div class="form-group field required">
                <label for="alias">{{ t('settings-connections-steps-title') }}</label>
                <input 
                    type="text" 
                    class="form-control" 
                    id="alias" 
                    v-model="form.alias" 
                    required
                />
            </div>

            <div
                class="field form-group"
                v-for="(field, index) in formFields"
                :key="index"
            >
                <custom-field 
                    :field="field"
                    v-model="form.form_fields[field.id]" 
                />
            </div>

            <div class="action-buttons mt-4">
                <button type="button" class="btn btn-secondary" @click="$emit('cancel')">{{ t('settings-connections-steps-cancel') }}</button>
                <button type="submit" class="btn btn-success" :disabled="saving">
                    <Icon icon-class="uiarrow-narrow-right" size="4" />
                    <span v-if="!saving">{{ t('settings-connections-steps-next') }}</span>
                    <span v-if="saving">{{ t('settings-connections-steps-saving') }}</span>
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import keviApi from '../../../../keviApi';
import CustomField from '../../../../components/custom-fields/custom-field.vue';

export default {
    name: 'StepConfigure',
    components: {
        CustomField,
    },
    props: {
        /**
         * Sender type definition (has form_fields, name, title, id)
         */
        sender: {
            type: Object,
            required: true,
        },
        /**
         * Existing place_sender data for editing (has id, alias, fields, senders_id)
         * Can be empty object for new configurations
         */
        placeSender: {
            type: Object,
            default: () => ({}),
        },
        /**
         * Channel type (sms, whatsapp, email, whatsapp-cloud)
         */
        channel: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            saving: false,
            formFields: [],
            form: {
                id: null,
                alias: '',
                channel: null,
                sender_id: null,
                form_fields: {},
            },
        };
    },
    methods: {
        initForm() {
            // Get form fields structure from sender type
            if (this.sender && this.sender.form_fields) {
                this.formFields = [...this.sender.form_fields];
            } else {
                this.formFields = [];
            }

            // Set form values
            const isEditing = this.placeSender && this.placeSender.id;
            
            this.form = {
                id: isEditing ? this.placeSender.id : null,
                alias: isEditing ? this.placeSender.alias : (this.sender?.title || ''),
                channel: this.channel || this.placeSender?.channel || this.sender?.channel,
                sender_id: isEditing ? (this.placeSender.senders_id || this.sender?.id) : this.sender?.id,
                form_fields: {},
            };

            // Populate form field values
            this.formFields.forEach((field) => {
                const existingValue = this.placeSender?.fields ? this.placeSender.fields[field.id] : '';
                this.$set(this.form.form_fields, field.id, existingValue || '');
            });
        },
        async save() {
            this.saving = true;
            const options = keviApi.getOptions(
                "/senders/save",
                "POST",
                JSON.parse(JSON.stringify(this.form)),
            );
            try {
                const response = await this.$http(options);
                const apiPlaceSender = response?.body?.place_sender || null;
                // Update form with returned id
                if (apiPlaceSender.id) {
                    this.form.id = apiPlaceSender.id;
                }

                this.$store.dispatch("notification/success", this.$_('settings-connections-notifications-config_saved_success'));
                this.$root.$emit('reload-senders');
                this.$emit('saved', apiPlaceSender);
            } catch (err) {
                this.$store.dispatch(
                    "notification/warning",
                    err.body?.message || this.$_('settings-connections-notifications-unknown_error'),
                );
            } finally {
                this.saving = false;
            }
        },
    },
    watch: {
        sender: {
            handler() {
                this.initForm();
            },
            deep: true,
            immediate: true,
        },
        placeSender: {
            handler() {
                this.initForm();
            },
            deep: true,
            immediate: true,
        },
    },
};
</script>

<style scoped lang="less">
.step-configure {
    .field,
    .form-group {
        margin-bottom: 16px;
    }

    .action-buttons {
        display: flex;
        gap: 12px;
        justify-content: stretch;
        
        button {
            flex: 1;
            justify-content: center;
        }
    }
}
</style>

